(function () {
  var params = new URLSearchParams(window.location.search);
  var collectionId = params.get('collection_id');
  var collectionTitle = params.get('collection_title');
  var collectionUrl = params.get('collection_url');

  if (collectionId && collectionTitle) {
    sessionStorage.setItem('bc_collection_id', collectionId);
    sessionStorage.setItem('bc_collection_title', collectionTitle);
    if (collectionUrl) sessionStorage.setItem('bc_collection_url', collectionUrl);
  }

  if (!collectionId) {
    collectionId = sessionStorage.getItem('bc_collection_id');
    collectionTitle = sessionStorage.getItem('bc_collection_title');
    collectionUrl = sessionStorage.getItem('bc_collection_url');
  }

  if (!collectionId || !collectionTitle) return;

  var originalPushState = history.pushState.bind(history);
  var originalReplaceState = history.replaceState.bind(history);

  function reattachParams(url) {
    if (!url) return url;
    try {
      var u = new URL(url, window.location.origin);
      if (u.pathname.includes('/products/') && !u.searchParams.get('collection_id')) {
        u.searchParams.set('collection_id', collectionId);
        u.searchParams.set('collection_title', collectionTitle);
        if (collectionUrl) u.searchParams.set('collection_url', collectionUrl);
      }
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  history.pushState = function (state, title, url) {
    return originalPushState(state, title, reattachParams(url));
  };

  history.replaceState = function (state, title, url) {
    return originalReplaceState(state, title, reattachParams(url));
  };

  function updateBreadcrumb() {
    // 商品ページ以外では動かさない
    if (!window.location.pathname.includes('/products/')) return;

    var breadcrumb = document.querySelector('nav.breadcrumb');
    if (!breadcrumb) return;

    // すでにコレクションリンクがある場合はスキップ
    var links = breadcrumb.querySelectorAll('a');
    if (links.length >= 2) return;

    var productSpan = breadcrumb.querySelector('span:last-of-type');
    if (!productSpan) return;

    var colLink = document.createElement('a');
    colLink.href = collectionUrl ? decodeURIComponent(collectionUrl) : '#';
    colLink.textContent = decodeURIComponent(collectionTitle);

    var sep = document.createElement('span');
    sep.className = 'breadcrumb__sep';
    sep.innerHTML = '<svg width="10" height="10" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style="vertical-align:middle;"><path d="M6 3L11 8L6 13" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    breadcrumb.insertBefore(sep, productSpan);
    breadcrumb.insertBefore(colLink, sep);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBreadcrumb);
  } else {
    updateBreadcrumb();
  }
})();
